import type {ValueOf} from '@myparcel-frontend/types';
import {TierName} from '@/types/subscriptions/tiers';

export const MyOrdersProductId = {
  Start: 4615,
  Plus: 4616,
  Premium: 4617,
  Max: 4618,
} as const;

export const MyOrdersTierName = {
  Start: TierName.Start,
  Plus: TierName.Plus,
  Premium: TierName.Premium,
  Max: TierName.Max,
} as const;

export const MY_ORDERS_IDS_TO_NAMES = {
  [MyOrdersProductId.Start]: MyOrdersTierName.Start,
  [MyOrdersProductId.Plus]: MyOrdersTierName.Plus,
  [MyOrdersProductId.Premium]: MyOrdersTierName.Premium,
  [MyOrdersProductId.Max]: MyOrdersTierName.Max,
};

export const toMyOrdersTierName = <T extends ValueOf<typeof MyOrdersProductId>>(id: T) => {
  return MY_ORDERS_IDS_TO_NAMES[id];
};

